import { render, staticRenderFns } from "./DescText.vue?vue&type=template&id=2800a310&scoped=true&"
import script from "./DescText.vue?vue&type=script&lang=js&"
export * from "./DescText.vue?vue&type=script&lang=js&"
import style0 from "./DescText.vue?vue&type=style&index=0&id=2800a310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2800a310",
  null
  
)

export default component.exports